import React, { useState } from 'react';
import { authAPI, setApiBaseUrl } from '../services/api';
import './LoginPage.css';

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [region, setRegion] = useState('au');
  const [environment, setEnvironment] = useState('staging');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const regions = [
    { id: 'au', name: 'Australia' },
    { id: 'us', name: 'United States' },
  ];

  const environments = [
    { id: 'dev', name: 'Development' },
    { id: 'staging', name: 'Staging' },
    { id: 'prod', name: 'Production' },
  ];



  const getApiUrl = (reg, env) => {

    // Staging: Multi-region
    if (env === 'staging') {
      if (reg === 'us') return process.env.REACT_APP_API_URL_STAGING_US || 'https://birt-api-us-stg.chronicle.rip';
      return process.env.REACT_APP_API_URL_STAGING_AUS || 'https://birt-api-aus-stg.chronicle.rip';
    }

    // Production: Multi-region
    if (env === 'prod') {
      if (reg === 'us') return process.env.REACT_APP_API_URL_PROD_US || 'https://birt-api-us.chronicle.rip';
      return process.env.REACT_APP_API_URL_PROD_AUS || 'https://birt-api-aus.chronicle.rip';
    }

    // Development: Single server (local)
    if (env === 'dev') {
      return process.env.REACT_APP_API_URL_DEV || 'http://localhost:8000';
    }

    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Determine the target API URL
      const apiUrl = getApiUrl(region, environment);
      const currentStoredUrl = localStorage.getItem('api_base_url');

      // If the URL has changed, we must update storage and reload
      // to ensure the API service uses the new URL.
      // If the URL has changed, update it dynamically
      if (currentStoredUrl !== apiUrl) {
        console.log(`Switching API URL from ${currentStoredUrl} to ${apiUrl}`);
        setApiBaseUrl(apiUrl);
      }

      // If URL is same (or just set), proceed with login
      console.log(`Attempting login to ${apiUrl}`);
      const response = await authAPI.login(username, password);
      // API returns { access, refresh, location, user }
      const { access, user } = response.data;
      // Store env + region for sidebar indicator
      localStorage.setItem('birt_environment', environment);
      localStorage.setItem('birt_region', region);
      onLogin(user, access);
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err.response?.data?.detail || 'Login failed. Please check your credentials and environment.'
      );
      // If network error, it might be the URL.
      if (!err.response) {
        setError(`Network error connecting to ${localStorage.getItem('api_base_url')}. Check if backend is running.`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box card">
        <div className="login-header">
          <h1>BIRT</h1>
          <p>Backup and Import Redesign Tool</p>
          <div className="login-divider"></div>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <div className="alert alert-error">{error}</div>}

          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-row">
            <div className="input-group">
              <label htmlFor="region">Region</label>
              <select
                id="region"
                value={region}
                onChange={(e) => setRegion(e.target.value)}
                disabled={loading}
                className="form-control"
              >
                {regions.map(r => (
                  <option key={r.id} value={r.id}>{r.name}</option>
                ))}
              </select>
            </div>

            <div className="input-group">
              <label htmlFor="environment">Environment</label>
              <select
                id="environment"
                value={environment}
                onChange={(e) => setEnvironment(e.target.value)}
                disabled={loading}
                className="form-control"
              >
                {environments.map(e => (
                  <option key={e.id} value={e.id}>{e.name}</option>
                ))}
              </select>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="login-footer">
          <p>Cemetery Data Management System</p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
